import * as Sentry from '@sentry/browser';
import { fetchResourceCollection } from '@backoffice/utils/api';
import { CONTRACT_HOUSING_CAPACITIES_TRAD_KEYS } from '@shared/contract/labels';
import { ApiResourceName } from '@shared/types/api/api';
import { uuidFromIri } from '@shared/utils/iri';
export const state = () => ({
    housingCapacities: [],
    initialized: false,
});
export const getters = {
    housingCapacitiesChoices(state) {
        return state.housingCapacities.map((housingCapacity) => ({
            value: uuidFromIri(housingCapacity.id),
            tradKey: CONTRACT_HOUSING_CAPACITIES_TRAD_KEYS[housingCapacity.code],
        }));
    },
};
export const actions = {
    async loadHousingCapacities({ commit, state }, force) {
        if (state.initialized && !force)
            return;
        try {
            const result = await fetchResourceCollection(ApiResourceName.HousingCapacities, this.$axios);
            commit('SET_HOUSING_CAPACITIES', result.data);
            commit('SET_INITIALIZED', true);
        }
        catch (err) {
            Sentry.captureException(err);
            commit('SET_HOUSING_CAPACITIES', []);
            commit('SET_INITIALIZED', false);
        }
    },
};
export const mutations = {
    SET_INITIALIZED(state, initialized) {
        state.initialized = initialized;
    },
    SET_HOUSING_CAPACITIES(state, housingCapacities) {
        state.housingCapacities = [...housingCapacities];
    },
};
